import { Config } from './config.model';

export const environment: Config = {
  production: false,
  name: 'pdn.release',
  urlAuthorityAM: 'https://lobbycloudgate.amx-digital.com',
  clientIdAM: 'cGnh421MUYfah218iBsCQGgN2IpM8H9n',
  AudienceAM: 'https://dev-tp-travel-aud/',
  IDPScopeAM: 'openid profile email',
  urlEnvRedirectAM: 'https://web-ui.tptravel.qa.ontp.app/integrations',
  auth0SkipRedirectCallbackURL: '/integrations',
  auth0UFederated: false,
  auth0UReturnTo: 'https://web-ui.tptravel.qa.ontp.app/end-process'
} as Config;
